import React from "react";
import {Grid, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import {useDispatch, useSelector} from "react-redux";
import {API_SPEC} from "../spec/apiSpec";
import {useApi} from "../hooks/api-hook";
import {useParams, useSearchParams} from "react-router-dom";
import {useNavigate} from "react-router";
import NoResults from "./NoResults";
import {saveLabels} from "../reducers/labelReducer";
import DataLoader from "./loaders/DataLoader";
import {useKeycloak} from "@react-keycloak/web";
import MtgTile from "./MtgTile";
import PaginatedComponent from "./hoc/PaginatedComponent";

const bull = (
    <Box
        component="span"
        sx={{display: 'inline-block', mx: '2px', transform: 'scale(0.8)'}}
    >
        •
    </Box>
);

export default function MtgCards() {
    const {keycloak, initialized} = useKeycloak();
    const {
        items: cards,
        page: {totalElements, number, totalPages, size},
        loading
    } = useSelector((state) => state.cardReducer)
    const {api} = useApi();
    const [searchParams, setSearchParams] = useSearchParams();
    const q = searchParams.get("q");
    const {set} = useParams();
    const navigate = useNavigate()
    const dispatch = useDispatch();

    const text = useSelector((state) => state.labelReducer.labels.searchResult);

    /*    if (cards.length === 1) {
            navigate(`/${cards[0].set}/${cards[0].collector_number}/${cards[0].name}`);
        }*/


    React.useEffect(() => {
        if (!set) {
            dispatch(saveLabels({searchResult: `Search results for: ${q}`}));
        }
    }, [q]);

    const handleChangePage = (newPage, rowsPerPage) => {
        const query = set ? `set:${set}` : q;
        const card_spec = API_SPEC.SEARCH_CARDS({q: query, page: newPage, size: rowsPerPage})
        api(card_spec);
        navigate(`/search?q=${query}&page=${newPage}&size=${rowsPerPage}`)
    };

    const handleChangeRowsPerPage = (size) => {
        const query = set ? `set:${set}` : q;
        const card_spec = API_SPEC.SEARCH_CARDS({q: query, page: 0, size: size})
        api(card_spec);
        navigate(`/search?q=${query}&page=0&size=${size}`)
    };

    const query = () => {
//        !restrictedFirstSegment.includes(firstSegment)
    }

    if (loading) {
        return (
            <DataLoader title={'loading cards ...'}/>
        )
    }

    return (
        <>
            {/* <Card sx={{marginTop: 4}}>
                <CardContent>
                    <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                        Guildmage Marketplace BETA
                    </Typography>
                    <Typography variant="body2" sx={{marginTop: 2}}>Start compiling your collection today and embark on
                        your journey towards becoming a Guildmage trading master. We're excited to have you on board and
                        look forward to unveiling our full trading functionality soon!</Typography>
                </CardContent>
                <CardActions>
                    {initialized && !!keycloak.authenticated ?
                        <Button component={Link} to={`/user/${keycloak.tokenParsed.preferred_username}`}>CREATE YOUR
                            COLLECTION</Button>
                        :
                        <Button onClick={() => keycloak.login()}>LOGIN</Button>
                    }
                </CardActions>
            </Card> */}
            <Box height={24}/>
            {/* {!q && <Box component={Link} to="/search?q=the%20lord%20of%20the%20rings"
                            sx={{borderRadius: 8, width: '100%', display: 'block'}}>
                    <img
                        src="https://guildmage.pl/images/ltr_sma_fb_groups_1640x680_en.jpg"
                        alt="The Lord of the Rings: Tales of Middle-earth"
                        style={{borderRadius: 8, width: '100%', height: '100%', objectFit: 'cover'}}
                    />
                </Box>
                } */}
            <Box sx={{marginTop: 4}}>
                {/*<Box*/}
                {/*    component="iframe"*/}
                {/*    src="https://crafty-crafter-6151.ck.page/d661132f97"*/}
                {/*    sx={{*/}
                {/*        flex: 1,*/}
                {/*        height: '800px',*/}
                {/*        width: '100%',*/}
                {/*        border: 'none'*/}
                {/*    }}*/}
                {/*/>*/}
                <Typography variant="h4">{text}</Typography>
            </Box>
            <PaginatedComponent size={cards.length} totalElements={totalElements} handleChangePage={handleChangePage}
                                handleChangeRowsPerPage={handleChangeRowsPerPage}>
                <Grid container spacing={{xs: 1, sm: 1, md: 2, lg: 3, xl: 4}}
                      columns={{xs: 2, sm: 4, md: 8, lg: 8, xl: 10}}>
                    {cards.length > 0 ? cards.map(c => <MtgTile card={c}/>) : <Box sx={{padding: 4}}><NoResults/></Box>}
                </Grid>
            </PaginatedComponent>
        </>


    );
}
